"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A simple generator to provide string labels, if a `startingPoint` is specified then
 * this is used as the starting point and returned as the first value.
 * The number of values generated can be restricted by specifying a `count` value greater than
 * -1 otherwise the number of values generated is unrestricted.
 *
 * @export
 *
 * @param {string} [startingPoint='a']  The starting point expected to be a-z characters
 * @param {number} [count=-1]
 *
 * @returns {IterableIterator<string>}
 */
function a2zzz(startingPoint, count) {
    var currentItem, cursor;
    if (startingPoint === void 0) { startingPoint = 'a'; }
    if (count === void 0) { count = -1; }
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                currentItem = startingPoint;
                cursor = count;
                _a.label = 1;
            case 1:
                if (!(cursor !== 0)) return [3 /*break*/, 3];
                return [4 /*yield*/, currentItem];
            case 2:
                _a.sent();
                currentItem = (parseInt(currentItem, 36) + 1)
                    .toString(36)
                    .replace(/[0-1]/g, 'a');
                if (cursor > -1) {
                    cursor -= 1;
                }
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
}
exports.a2zzz = a2zzz;
var a2z = /** @class */ (function () {
    function a2z() {
    }
    /**
     * A generator for labels 'a' onwards
     *
     * @alias a2zzz()
     *
     * @returns IterableIterator<string>
     */
    a2z.simple = function () {
        return a2zzz('a');
    };
    /**
     * A generator for a limited number of labels 'a' onwards
     *
     * @alias a2zzz('a', count)
     *
     * @param {number} count The number of labels to generate
     *
     * @returns IterableIterator<string>
     */
    a2z.limit = function (count) {
        return a2zzz('a', count);
    };
    /**
     * A generator with a specified start label and optional limit
     *
     * @param {string} startingPoint
     * @param {number} [count=-1]
     *
     * @returns IterableIterator<string>
     */
    a2z.standard = function (startingPoint, count) {
        if (count === void 0) { count = -1; }
        return a2zzz(startingPoint, count);
    };
    return a2z;
}());
exports.default = a2z;
